// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"2":"ad230333","3":"aa4cafbc","97":"928e5d59","100":"183f82ff","149":"3e995c6a","190":"725a3503","206":"94931d23","436":"49a46405","627":"963aaea3","881":"1db56a0c"}[chunkId] + ".chunk.js";
};